import ActionSelect from './ActionSelect';

import { CustomerSelect } from '@/components/CustomerSelect';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select';

interface LogsFiltersProps {
  action?: string;
  customerId?: string;
  perPage?: number;
  onActionChange?: (action: string) => void;
  onCustomerChange?: (customerId: string) => void;
  onPerPage?: (value: number) => void;
}

export function LogsFilters({
  action,
  customerId,
  perPage,
  onActionChange,
  onCustomerChange,
  onPerPage,
}: LogsFiltersProps) {
  function handleActionChange(action: string) {
    onActionChange?.(action);
  }

  function handleCustomerChange(customerId: string) {
    onCustomerChange?.(customerId);
  }

  return (
    <div className="flex items-center justify-between gap-4 py-6">
      <ActionSelect
        value={action}
        onValueChange={handleActionChange}
        additionalOptions={[{ value: '0', label: 'All Actions' }]}
      />

      <CustomerSelect
        value={customerId?.toString()}
        onValueChange={handleCustomerChange}
        additionalOptions={[
          { value: '0', label: 'All Customers' },
          { value: '-1', label: 'Root' },
        ]}
      />

      <Select
        value={(perPage ?? '').toString()}
        onValueChange={(value) => {
          onPerPage?.(Number(value));
        }}
      >
        <SelectTrigger className="w-[300px]">
          <SelectValue placeholder="Items per page" />
        </SelectTrigger>
        <SelectContent>
          {[5, 10, 20, 50].map((n) => (
            <SelectItem key={n} value={n.toString()}>
              {n} per page
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
